import React from "react";
import scan from "../images/scan.svg";
import collect from "../images/trash.svg";
import { useSpring, animated } from "react-spring";

export default function Boxes() {
  const boxAnimate = useSpring({
    transform: "translate3d(0px,0,0) scale(1) rotateX(0deg)",
    from: { transform: "translate3d(0px,0,0) scale(0) rotateX(0deg)" },
  });

  return (
    <div className="boxDiv">
      <animated.span className="box" style={boxAnimate}>
        <img src={scan} alt="first box" />
        <h2>Scan</h2>
        <p>at the register to apply your points</p>
      </animated.span>

      <animated.span className="box" style={boxAnimate}>
        <img src={collect} alt="first box" />
        <h2>Collect</h2>
        <p>two Points for Every Dollar</p>
      </animated.span>

      <animated.span className="box" style={boxAnimate}>
        <img src={collect} alt="first box" />
        <h2>Redeem</h2>
        <p>For some pretty tasty rewards</p>
      </animated.span>
    </div>
  );
}
